export function invoke(fn:any, ...parameters:any) {
    if('function' === typeof fn) {
        fn(...parameters);
    }
}
